/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import Text from 'ol/style/text';
import { mergeDescriptors, style, withFillStrokeStyle } from '../core';

var props = {
  font: {
    type: String,
    default: '10px sans-serif' // css font format https://developer.mozilla.org/en-US/docs/Web/CSS/font?v=control
  },
  offsetX: {
    type: Number,
    default: 0
  },
  offsetY: {
    type: Number,
    default: 0
  },
  rotateWithView: {
    type: Boolean,
    default: false
  },
  rotation: {
    type: Number,
    default: 0
  },
  scale: {
    type: Number,
    default: 1
  },
  text: String,
  textAlign: {
    type: String,
    default: 'start' // left, right, center, end, start
  },
  textBaseline: {
    type: String,
    default: 'alphabetic' // bottom, top, middle, alphabetic, hanging, ideographic
  }
};

var methods = {
  /**
   * @returns {ol.style.Text}
   * @protected
   */
  createStyle: function createStyle() {
    return new Text({
      font: this.font,
      offsetX: this.offsetX,
      offsetY: this.offsetY,
      rotateWithView: this.rotateWithView,
      rotation: this.rotation,
      scale: this.scale,
      text: this.text,
      textAlign: this.textAlign,
      textBaseline: this.textBaseline,
      fill: this._fill,
      stroke: this._stroke
    });
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.setText(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.setText(undefined);
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(style.methods.getServices.call(this), {
      get stylesContainer() {
        return vm;
      }
    });
  }
};

var watch = {
  font: function font(value) {
    if (!this.$style) return;

    this.$style.setFont(value);
    this.refresh();
  },
  offsetX: function offsetX(value) {
    if (!this.$style) return;

    this.$style.setOffsetX(value);
    this.refresh();
  },
  offsetY: function offsetY(value) {
    if (!this.$style) return;

    this.$style.setOffsetY(value);
    this.refresh();
  },
  rotation: function rotation(value) {
    if (!this.$style) return;

    this.$style.setRotation(value);
    this.refresh();
  },
  scale: function scale(value) {
    if (!this.$style) return;

    this.$style.setScale(value);
    this.refresh();
  },
  text: function text(value) {
    if (!this.$style) return;

    this.$style.setText(value);
    this.refresh();
  },
  textAlign: function textAlign(value) {
    if (!this.$style) return;

    this.$style.setTextAlign(value);
    this.refresh();
  },
  textBaseline: function textBaseline(value) {
    if (!this.$style) return;

    this.$style.setTextBaseline(value);
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-text',
  mixins: [style, withFillStrokeStyle],
  props: props,
  methods: methods,
  watch: watch,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  }
};

var index = {
  Style: Style,
  install: function install(Vue) {
    Vue.component(Style.name, Style);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/text-style/index.es.js
// module id = null
// module chunks = 